import styled from 'styled-components';

import { body } from '@constants/fonts';

export const Tab = styled.div<{ active: boolean; width: number }>`
  width: ${(props) => props.width}%;
  color: ${(props) =>
    props.active
      ? props.theme.palette.primary.contrastText
      : props.theme.palette.text.primary};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  padding: 0px 7px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0px 2px;
    word-break: break-word;
  }

  transition: all 0.3s ease-out;
`;

export const CountLabel = styled.span`
  color: inherit;
  font-weight: inherit;
  opacity: 0.7;
`;

export const ActiveTab = styled.div<{ position: number; width: number }>`
  width: ${(props) => props.width}%;
  position: absolute;
  border-radius: 29px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  top: 2px;
  bottom: 2px;
  left: ${(props) =>
    `calc(${props.width * props.position}% + ${
      props.width * props.position ? '-2px' : '2px'
    })`};
  transition: all 0.3s ease-out;
`;

export const ViewTabStyle = styled.div<{ height: number }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.palette.grey['300']}99;
  border-radius: 29px;
  width: 100%;
  box-sizing: border-box;
  user-select: none;
  height: ${(props) => props.height}px;

  font-family: ${body};
  text-transform: uppercase;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 10px;
  }

  &:hover {
    ${ActiveTab} {
      background-color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`;
